import { __assign } from "tslib";
export function formatDollars(amount, options) {
    if (options === void 0) { options = {}; }
    if (amount === undefined) {
        return '';
    }
    if (typeof amount === 'string') {
        return "$".concat(amount);
    }
    return Intl.NumberFormat('en-US', __assign({ style: 'currency', currency: 'USD', useGrouping: false }, options)).format(amount);
}
//# sourceMappingURL=formatting.js.map